import React from 'react'
import styled from 'styled-components'
import AnchorLink from 'react-anchor-link-smooth-scroll'

const Grid = styled.div`
  text-align:left;
  display: grid;
  grid-template-columns: ${props => (props.hasIcons?'140px auto':'auto')};
  p{
    text-align: left;
  }
  a{
    text-decoration:underline;
  }
  @media (max-width: ${props => (props.theme.breaks.mobile)}px) {
    grid-template-columns: ${props => (props.hasIcons?'60px auto':'auto')};
  }
`;

const Icon = styled.div`
  width:75px;
  height:75px;
  cursor:pointer;
  border: 2px solid white;
  border-radius: 50%;
  background-size: 35%;
  background-position: center;
  background-repeat: no-repeat;

  ${props => (props.theme.shadow)}
  :hover{
    background-color: ${props => (props.theme.colors.bg)};
  }
  @media (max-width: ${props => (props.theme.breaks.mobile)}px) {
    width:30px;
    height:30px;
    font-size: 1em;
  }
`;

const TextIcon = styled(Icon)`
  background-color: ${props => (props.active==='text'?props.theme.colors.bg:props.theme.colors.bg2)};
  background-image: url("./img/layout/text.svg");
  background-size: 45%;
  margin-top: 18px;
`;

const QuestionIcon = styled(Icon)`
  background-color: ${props => (props.active==='question' || props.active==='answer'?props.theme.colors.bg:props.theme.colors.bg2)};
  color: #fff;
  background-image: url("./img/layout/questionMark.svg");
  margin-bottom: 18px;
`;

const InfoIcon = styled(Icon)`
  background-color: ${props => (props.active==='info'?props.theme.colors.bg:props.theme.colors.bg2)};
  font-weight: bold;
  font-size: 2em;
  text-align: center;
  display: table-cell;
  vertical-align: middle;
  color:#fff;
`;

const Antwort = styled.p`
  text-decoration: underline;
  cursor: pointer;
`;

const TopLink = styled(AnchorLink)`
  float:right;
  font-weight:bold;
  font-size: 40px;
`;
const ToTopIcon = styled(Icon)`
  background-color: ${props => (props.theme.colors.bg2)};
  background-image: url("./img/layout/pfeilNachOben.svg");
  background-size: 30%;
  margin-right:0;
  margin-top:18px;
`;
const GridContainer = styled.div`
  margin:0 0 200px 0;
  @media (max-width: ${props => (props.theme.breaks.mobile)}px) {
    margin:0 0 90px 0;
  }
`;

function showIcons(props){
  var cl = 0;
  var contents = ['text','question','info'];
  contents.forEach(function(c){
    if(props[c] !== undefined && props[c] !== ''){
        cl++;
    }
  });
  return cl > 1;
}

export default class ItemQA extends React.Component {
  constructor(props) {
    super(props);
    this.state = {active: props.text!==undefined?'text':'info'};
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(active) {
    //console.log(this.state);
    this.setState(state => ({
      active: active
    }));
  }

  render() {
    return (
      <GridContainer>
        <Grid hasIcons={showIcons(this.props)}>
          {showIcons(this.props) &&
            <div>
              {this.props.question !== undefined && this.props.question !== '' &&
                <QuestionIcon active={this.state.active} onClick={()=> this.handleClick('question')} />
              }
              {this.props.info !== undefined && this.props.info !== '' &&
                <InfoIcon active={this.state.active} onClick={()=> this.handleClick('info')}>i</InfoIcon>
              }
              {this.props.text !== undefined && this.props.text !== '' &&
                <TextIcon active={this.state.active} onClick={()=> this.handleClick('text')} />
              }
            </div>
          }
          {this.props.isReady &&
            <div>
              <div dangerouslySetInnerHTML={{__html: this.props[this.state.active]}} />
              {this.state.active === 'question' && this.props.Antwort !== '' &&
                <Antwort onClick={()=> this.handleClick('answer')}>{this.props.Antwort}</Antwort>
              }
            </div>
          }
          {!this.props.isReady &&
            <div  dangerouslySetInnerHTML={{__html: this.props.notReadyContent}} />
          }
        </Grid>
        <TopLink href="#topNavi"><ToTopIcon /></TopLink>
        <br style={{clear:"both"}} />
      </GridContainer>
    )
  }
}
